module.exports = __webpack_public_path__ + "img/kpi_diagram_blank.b8dc7f8c.png";